export function useStripTags(htmlString: string): string {
  if (typeof htmlString !== 'string' || htmlString === null || htmlString === undefined) {
    return ''
  }
  return htmlString.replace(/<[^>]*>/g, '').trim()
}
